<script>
import {
  DISCOUNT_IN_KOPECK,
} from '@/components/SwitchDiscountType.vue';
import InputDiscountInRubles from '@/components/InputDiscountInRubles.vue';
import InputDiscountInPercent from '@/components/InputDiscountInPercent.vue';

/**
 * @description Название события вода.
 * @type {string}
 */
const NAME_EVENT_INPUT = 'input';

/**
 * @description Название события потери фокуса.
 * @type {string}
 */
const NAME_EVENT_BLUR = 'blur';

/**
 * @description Постфикс для скидки в рублях.
 * @type {string}
 */
const KOPECK_POSTFIX = 'Тенге';

/**
 * @description Постфикс для скидки в процентах.
 * @type {string}
 */
const PERCENT_POSTFIX = '%';

/**
 * @description Поле ввода скидки в процентах.
 * @type {Vue}
 */
export default {
  components: {
    InputDiscountInPercent,
    InputDiscountInRubles,
  },
  name: 'InputDiscount',
  computed: {
    /**
     * @description Скидочный постфикс.
     * @type {string}
     */
    discountPostfix() {
      return this.discountType === DISCOUNT_IN_KOPECK ? KOPECK_POSTFIX : PERCENT_POSTFIX;
    },
  },
  props: {
    /**
     * @description Деактивирован.
     * @type {boolean}
     */
    disabled: { default: () => false, type: Boolean },
    /**
     * @description Тип скидки.
     * @type {string}
     */
    discountType: { required: true, type: String },
    /**
     * @description Значение скидки.
     * @type {number}
     */
    value: { required: true, type: Number },
    /**
     * @description Максимальная скидка в копейках.
     * @type {number}
     */
    maxDiscountInKop: { required: true, type: Number },
    /**
     * @description Нарушения ограничений.
     * @type {string[]}
     */
    violations: { default: () => [], type: Array },
    /**
     * @description Показывать значок скидки.
     * @type {boolean}
     */
    showDiscountPostfix: { default: false, type: Boolean },
  },
  render(createElement) {
    const onInput = (value) => this.$emit(NAME_EVENT_INPUT, value);
    const onBlur = () => this.$emit(NAME_EVENT_BLUR);
    const children = [];
    if (this.discountType === DISCOUNT_IN_KOPECK) {
      children.push(createElement(InputDiscountInRubles, {
        on: {
          blur: onBlur,
          input: onInput,
        },
        props: {
          disabled: this.disabled,
          maxDiscountInKop: this.maxDiscountInKop,
          value: this.value,
        },
      }));
    } else {
      children.push(createElement(InputDiscountInPercent, {
        on: {
          blur: onBlur,
          input: onInput,
        },
        props: {
          disabled: this.disabled,
          value: this.value,
          size: 'small',
        },
      }));
    }
    children.push(
      ...this.violations.map((violation, index) => createElement('p', {
        staticClass: 'violation',
        key: index,
      }, violation)),
    );
    if (this.showDiscountPostfix) {
      children.push(
        createElement('span', this.discountPostfix),
      );
    }
    return createElement('div', { staticClass: 'discount-field' }, children);
  },
};
</script>

<style scoped>
.discount-field {
  display: flex;
  align-items: center;
  gap: 5px;
}
.violation {
  color: var(--warning-color);
  font-size: 12px;
  font-weight: 400;
  padding: .125rem;
}
</style>
